import { render } from "./NewUser.vue?vue&type=template&id=cd2f5158&scoped=true"
import script from "./NewUser.vue?vue&type=script&lang=js"
export * from "./NewUser.vue?vue&type=script&lang=js"

import "./NewUser.vue?vue&type=style&index=0&id=cd2f5158&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cd2f5158"]])

export default __exports__